import { providerFlow, patientFlow } from '.';
export const getTroubleshootingFlow = (isPatient) => {
    return isPatient ? patientFlow : providerFlow;
};
